(ns manatee.admin.users.subs
  "App. DB subscriptions for the admin. users tab."
  (:require
   [manatee.admin.users.app-db :as db]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::list-view?
 (fn list-view?
   [db _]
   (db/list-view? db)))
